import React, { Component } from 'react'
import cubeApiClient from '../BusinessObjects/cubeApiService';

import LoggedContext from '../BusinessObjects/LoggedContext';
import ResourceField from '../Models/ResourceField';
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';
import EsaedroLookup from './EsaedroLookup';
import { renderGridObject } from '../Utils/EsaedroHelper';
import { themeEditButton, themeDeleteButton, themeNewButton, themeCol12xl, themeStripedTable, themeExpandButton, themeGroup, themeCol9, themeSpinner, themeFormInput } from '../Utils/EsaedroTheme';
import { Row, Col, Button, InputGroup, InputGroupAddon, Input, ButtonGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EsaedroPager from './EsaedroPager';
import EsaedroFilterConfig from './EsaedroFilterConfig';

interface EsaedroObjectListProps {
    myObjType: string;
    myObjUrl: string;
    myRowObjType?: string;
    myRowObjUrl?: string;
    myRowObjLinkFields?: string;
    onObjectEdit?(objectToEdit: any): void;
    onObjectDelete?(objectToDel: any): void;
    onObjectCreate?(): void;
    onInputFiltersUpdate?(filters: EsaedroResourceFilter[]): void
    onPageUpdate?(page: number): void
    navigationFilters?: EsaedroResourceFilter[];
    startingInputFilters?: EsaedroResourceFilter[];
    startingPage?: number;
    totalPages?: number;
    hideButtons?: boolean;
    hideFilters?: boolean;
    canCreate?: boolean;
    canUpdate?: boolean;
    canDelete?: boolean;
}

interface EsaedroObjectsListState {
    myObjects: any[];
    myObjectsToDisplay: any[];
    myObjectFields: ResourceField[];
    myObjectInputFilters: EsaedroResourceFilter[];
    myObjectViewFilters: EsaedroResourceFilter[];
    toggleFilters: boolean;
    loading: boolean;
    errorMessage:string;
}

const pageSize = 10

export default class EsaedroObjectsList extends Component<EsaedroObjectListProps, EsaedroObjectsListState> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    currentPage: number = 1
    totalPages: number = 1 

    constructor(props: EsaedroObjectListProps) {
        super(props);

        this.state = {
            myObjects: [],
            myObjectsToDisplay: [],
            myObjectFields: [],
            myObjectInputFilters: [],
            myObjectViewFilters: [],
            toggleFilters: false,
            loading: true,
            errorMessage: ''
        }
    }

    componentDidMount() {

        // La prima cosa che faccio è recuperare gli item della pagina 1
        this.getPageItems(this.props.startingPage?this.props.startingPage:1)
    }

    // Callback alla funzione di EsaedroContentPage per andare nell'edit dell'oggetto
    setItemToEdit = (item: any) => {
        if (this.props.onObjectEdit!=undefined) {
            this.props.onObjectEdit(item)
        }
    }

    // Callback alla funzione di EsaedroContentPage per andare nel delete dell'oggetto
    setItemToDelete = (item: any) => {
        if (this.props.onObjectDelete!=undefined) {
            this.props.onObjectDelete(item)
        }
    }

    // Callback alla funzione di EsaedroContentPage per andare nella creazione di un oggetto
    goToNewItem = () => {
        if (this.props.onObjectCreate!=undefined) {
            this.props.onObjectCreate()
        }
    }
    
    // Espande una testata mostrando le sue righe
    expandObject = (index: number) => {
        if (this.state.myObjectsToDisplay.length > index) {
            let newObjects = this.state.myObjectsToDisplay
            newObjects[index].Expanded = !newObjects[index].Expanded
            this.setState({myObjectsToDisplay: newObjects})
        }
    }

    // Chiama il servizio per ottenere gli item da mostrare in una determinata pagina, tenendo conto dei filtri
    getPageItems = (page: number) => {

        this.currentPage = page
        this.setState({loading: true})

        if (this.props.onPageUpdate!=undefined) {
            this.props.onPageUpdate(page)
        }

        const service = new cubeApiClient();
        const t = this.context.tokenAPI;

        let filterString = ""
        // Applico eventuali filtri da jump o menu di navigazione
        if (this.props.navigationFilters)
        {
            for(var i=0;i< this.props.navigationFilters.length;i++)
            {
                filterString += (i?" and ":"") 
                                + this.props.navigationFilters[i].FieldName 
                                + this.props.navigationFilters[i].Operator 
                                + "'" + this.props.navigationFilters[i].Value + "'"
            }
        }

        // Applico anche i filtri eventuali impostati dalla maschera
        let filtersToAppend = ''
        // Prendo gli input filters dalle props o dallo stato a seconda del caso in cui ci troviamo
        let inputFilters = this.state.myObjectInputFilters.length
                            ?this.state.myObjectInputFilters
                            :this.props.startingInputFilters
                                ?this.props.startingInputFilters
                                :undefined
        if (inputFilters) {

            if (filterString>'') filtersToAppend = " and "

            let found = false
            inputFilters.forEach(element => {
                if (element.Value!='') {
                    filtersToAppend += (found?" and ":"") 
                    + 'lower('
                    + element.FieldName
                    + ')'
                    + element.Operator 
                    + 'lower('
                    + "'%" + element.Value + "%'"
                    + ')'
                    found = true
                }
            });

            if (!found) filtersToAppend = ''
        }

        // Aggiungo eventuali filtri della vista
        // TODO qui utilizzare l'oggetto EsaedroResourcesView e aggiungerla come parametro alla richiesta
        if (this.state.myObjectViewFilters) {

            let oldFiltersToAppend = filtersToAppend

            if (filtersToAppend>'') filtersToAppend += " and "
            else if (filterString>'') filtersToAppend = " and "

            let found = false
            this.state.myObjectViewFilters.forEach(element => {
                if (element.Value!='') {
                    filtersToAppend += (found?" and ":"") 
                    + 'lower('
                    + element.FieldName
                    + ')'
                    + element.Operator 
                    + 'lower('
                    + "'%" + element.Value + "%'"
                    + ')'
                    found = true
                }
            });

            if (!found) filtersToAppend = oldFiltersToAppend
        }
        
        const requrl = this.props.myObjUrl + ((filterString+filtersToAppend)>""?'?RecordSelection=':'') + encodeURIComponent(filterString + filtersToAppend) + ((filterString+filtersToAppend)>""?"&PageSize="+pageSize+"&PageNumber="+page:"?PageSize="+pageSize+"&PageNumber="+page)
        
        // Per debug
        //alert(requrl)

        service
            .getItems(requrl,t)
            .then((data: any) => {

                if (this.props.myRowObjType != undefined && this.props.myRowObjUrl != undefined) {
                    // Se è un oggetto HeaderRow setto Expanded a false per tutti gli elementi
                    data.forEach((element: any) => {
                        element.Expanded = false
                    });
                }

                if (data[0]) 
                {
                    this.totalPages = data[0].PageCount
                }
                else this.totalPages = 1

                this.setState({ myObjects: data, myObjectsToDisplay: data });
                const reqFieldsurl ='api/sys/ResourcesFields?RecordSelection=' + encodeURIComponent("ResourceName='" + this.props.myObjType + "' and Referred_Resource_ID is null and Is_Grid=1") 

                service
                    .getItems(reqFieldsurl,t)
                    .then((data: any) => {
                        // In caso fossero vuoti li creo a partire dai resourceFields, altrimenti dalle props
                        if (!this.state.myObjectInputFilters.length) this.createStartingInputFilters(data)
                        this.setState({ 
                            myObjectFields: data, 
                            loading: false 
                        });
                    },
                    (error: any) => {
                        this.setState({ 
                            myObjects: [], 
                            myObjectsToDisplay: [], 
                            loading: false, 
                            errorMessage: error 
                        });
                    });

            },
            (error: any) => {
                this.setState({ 
                    myObjects: [], 
                    myObjectsToDisplay: [], 
                    loading: false, 
                    errorMessage: error 
                });
            });
    }

    // Filtra gli oggetti ma solo di una lookup HARDCODED
    filterObjects = (e: any) => {
        // TODO mettere controllo e cercare di fare dinamico, funziona solo per il filtro fatto a mano tramite lookup
        let updateList = this.state.myObjects;

        updateList = updateList.filter(item => {
        return item.Resource_ID.toString().toLowerCase().search(
            e.target.value.toLowerCase()
            ) !== -1;
        });

        this.setState({
            myObjectsToDisplay: updateList
        });
    }

    // Crea i filtri in input iniziali: possono essere impostati da chi crea il component o vuoti in base alle proprietà con isGrid = 1
    createStartingInputFilters = (myFields: ResourceField[]) => {
        // Creo i filtri dalla property se settata
        if (this.props.startingInputFilters && this.props.startingInputFilters.length) {
            let newFilters : EsaedroResourceFilter[] = []
            this.props.startingInputFilters.forEach(filter => {
            newFilters.push(new EsaedroResourceFilter(filter.FieldName, filter.Value, filter.Operator, filter.description))
            });
            this.setState({myObjectInputFilters: newFilters})
        }
        // Altrimenti li creo vuoti
        else if (myFields.length){
            let myFilters: EsaedroResourceFilter[] = []
            myFields.map((field: ResourceField) => {
                if (field.Field_Type == 4 || 
                    field.Field_Type == 15 || 
                    field.Field_Type == 33) {                    
                       myFilters.push(new EsaedroResourceFilter(field.FieldName, '', ' like ', field.Field_Label, "datetime-local"))
                    }
                else if (field.Field_Type == 31) {                    
                       myFilters.push(new EsaedroResourceFilter(field.FieldName, '', ' like ', field.Field_Label, "date"))
                    }
                else myFilters.push(new EsaedroResourceFilter(field.FieldName, '', ' like '))
            })
            this.setState({myObjectInputFilters: myFilters})
        }
    }

    // Svuota i filtri in input e ricarica la vista chiamando gli item di pagina 1
    resetInputFilters = () => {
        this.state.myObjectInputFilters.forEach(element => {
            element.Value = ''
        });
        this.getPageItems(1)
    }

    // Fa l'update dei filtri in input (alla digitazione) senza però far partire nessun procedimento di filtraggio 
    updateInputFilters = (e: any) => {
        let newFilters = this.state.myObjectInputFilters
        newFilters[e.target.max].Value = e.target.value
        this.setState({myObjectInputFilters: newFilters})
    }

    // Applica i filtri in input e chiama la pagina 1. Con un callback manda i filtri all'HistoryItem della EsaedroContentPage
    applyInputFilters = () => {
        this.getPageItems(1)
        if (this.props.onInputFiltersUpdate!=undefined) {
            this.props.onInputFiltersUpdate(this.state.myObjectInputFilters)
        }
    }

    toggleFilterBtnPressed = () => {
        this.setState({toggleFilters: !this.state.toggleFilters})
    }

    viewFiltersUpdated = (viewFilters?: EsaedroResourceFilter[], errorMessage?: string) => {
        // Torno dalla vista che ha settato i filtri. TODO save. Per ora li mando come parametro e ricarico pagina 1
        if (viewFilters) {
            this.setState({ myObjectViewFilters: viewFilters,
                            toggleFilters: !this.state.toggleFilters,
                            errorMessage:errorMessage?errorMessage:"" })
            
            this.getPageItems(1)
        }
        else if (errorMessage && errorMessage>"") {
            this.setState({ toggleFilters: !this.state.toggleFilters, errorMessage: errorMessage})
        } 
    }

    render() {

        const { myObjectsToDisplay } = this.state;

        let toggleFilterButton = <Button color="primary" onClick={this.toggleFilterBtnPressed}>Apri Filtri</Button>

        // TODO CHANGE Applica button con il fare qualcosa :D
        let filtersModal = <Modal isOpen={this.state.toggleFilters} toggle={this.toggleFilterBtnPressed} size="lg">
                            <ModalHeader toggle={this.toggleFilterBtnPressed}>Filtri Ricerca</ModalHeader>
                            <ModalBody>
                                <EsaedroFilterConfig myObjType={this.props.myObjType} myObjectFields={this.state.myObjectFields} onReturn={this.viewFiltersUpdated}></EsaedroFilterConfig>     
                            </ModalBody>
                        </Modal>

        // Creo il pager
        let navigation = <EsaedroPager currentPage={this.currentPage} totalPages={this.totalPages} onClick={this.getPageItems}></EsaedroPager>

        if (this.state.loading)
        {
            return (
                <Row className={themeGroup()}>
                <Col className={themeCol9()}>
                    <i className={themeSpinner()}></i>   Caricamento...  
                </Col>
                </Row>
            )
        }

        // Il rendering si basa sempre sugli oggetti da mostrare
        if (myObjectsToDisplay && myObjectsToDisplay.length) {

            // Calcolo la size totale dei fields da mostrare
            var totalSize = 0
            this.state.myObjectFields.forEach((field: ResourceField) => {
                totalSize+=field.Field_Size
            })

            let objectsData = myObjectsToDisplay.map((item: any, index) => {

                // Splitto la stringa di campi su cui filtrare e creo gli EsaedroResourceFilter da mandare alla ObjectList delle rows
                var rowsFilters = undefined
                if (this.props.myRowObjLinkFields != undefined) {
                    // Per ora metto uguale per tutti in questo caso. Capire se bisogna gestirla diversamente
                    rowsFilters = []
                    let rowsFiltersFields = this.props.myRowObjLinkFields.split(',')
                    rowsFiltersFields.map(element => {
                        rowsFilters.push(new EsaedroResourceFilter(element,item[element],"="));
                    });
                }
                // Per gli edit del detail, entrare in testata e poi fare edit da li
                let rows = (this.props.myRowObjType != undefined && this.props.myRowObjUrl != undefined) &&
                    (item[this.props.myRowObjType] && item.Expanded) &&
                        <tr>
                            <td colSpan={this.state.myObjectFields.length+1}>
                                <EsaedroObjectsList 
                                    myObjType={this.props.myRowObjType} 
                                    myObjUrl={this.props.myRowObjUrl} 
                                    hideButtons={true} 
                                    hideFilters={true}
                                    navigationFilters={rowsFilters}> 
                                </EsaedroObjectsList>
                            </td>
                        </tr>
                        
                // Creo i vari pulsanti in base ai parametri del component
                let buttons = undefined
                if (!this.props.hideButtons) {

                        // Se l'oggetto non può essere modificato gli setto una property in più
                        item.disableEdit = !this.props.canUpdate

                        let editButton = this.props.canUpdate ?
                            <Button className={themeEditButton()} onClick={() => this.setItemToEdit(item)}> <i className="fa fa-edit">  </i> </Button>
                            : <Button className={themeEditButton()} onClick={() => this.setItemToEdit(item)}> <i className="fa fa-search">  </i> </Button>
                        
                        let deleteButton = this.props.canDelete &&
                            <Button className={themeDeleteButton()} onClick={() => this.setItemToDelete(item)}><i className="fa fa-trash"></i></Button>
                        
                        let expandButton = (this.props.myRowObjType && this.props.myRowObjUrl) &&
                            <Button className={themeExpandButton()} onClick={() => this.expandObject(index)}><i className={item.Expanded?"fa fa-angle-right":"fa fa-angle-down"}></i></Button>
                        
                        buttons =   <td>
                                        <ButtonGroup>
                                            {editButton}
                                            {deleteButton}
                                            {expandButton}
                                        </ButtonGroup>
                                    </td>
                }

                return (
                    <tbody key={index}>
                    <tr style={item.Expanded?{background: 'grey'}:{}}>
                        {buttons?buttons:''}
                        {
                            this.state.myObjectFields.map((field: ResourceField, index) => {
                                return renderGridObject(field, item, index, totalSize, this.state.myObjectFields.length)
                            })
                        }            
                    </tr>
                    {item.Expanded?rows:undefined}
                    </tbody>
            )});
            // Filtro per le maschere - HardCoded. Da mettere tramite struttura dei Menu
            let filterLookup = this.props.myObjType=="ResourcesFields"
                ?   <EsaedroLookup 
                        name="LKPRESOURCESMASK" 
                        isSys={true} 
                        value={undefined} 
                        fatherObj={undefined}
                        onChange={this.filterObjects} 
                        lookupName="LKPRESOURCESMASK" 
                        lookupValues='' 
                        displayName="Filtro Risorse"
                    />
                : ''

            let contents = this.state.loading
                ?   <tr><td colSpan={this.state.myObjectFields.length+1} style={{"textAlign":"center"}}><span>Loading...</span></td></tr>
                :   objectsData;

            let newItem = !this.props.hideButtons && this.props.canCreate
                ?   <th><Button className={themeNewButton()}  value="Nuovo" onClick={this.goToNewItem}><i className="fa fa-plus"></i></Button></th>
                :   this.props.hideButtons
                                ?undefined
                                :<th></th>

            return (
            <div>
                {filterLookup}
                {toggleFilterButton}
                {filtersModal}
                <div className="row">
                    <div className={themeCol12xl()}>
                        <table className={themeStripedTable()}>
                            <thead>
                                <tr>
                                    {newItem?newItem:''}
                                    {
                                        this.state.myObjectFields.map((field: ResourceField, index) => {
                                            return (
                                                <th key={index}>{field.Field_Label}</th>
                                            )
                                        })
                                    }
                                </tr>
                                <tr>{!this.props.hideFilters
                                        ?<th><Button onClick={this.resetInputFilters} color="outline-info"> <i className="fa fa-refresh"></i></Button></th>
                                        : undefined
                                    }
                                    {!this.props.hideFilters
                                        ? this.state.myObjectInputFilters.map((filter: EsaedroResourceFilter, index) => {
                                            // Qui gestire filtri di altro tipo
                                            return (
                                                <th key={index}> 
                                                    <InputGroup>
                                                        <InputGroupAddon 
                                                            addonType="prepend">
                                                                <Button 
                                                                    size="sm" 
                                                                    onClick={this.applyInputFilters} 
                                                                    color="outline-info"><i 
                                                                    className="fa fa-filter"> </i>
                                                                </Button>
                                                        </InputGroupAddon>
                                                        <Input 
                                                            className={themeFormInput()} 
                                                            type={filter.filterType} 
                                                            name={filter.FieldName} 
                                                            value={filter.Value}
                                                            max={index}
                                                            onChange={this.updateInputFilters}/>
                                                    </InputGroup>
                                                </th>
                                            )
                                        })
                                        : undefined
                                    }
                                </tr>
                            </thead>
                            {contents}
                            {navigation}
                        </table>
                    </div>
                </div>
            </div>
            )
        }
        else {
            return (
            <div className="container">
                <div className="row">
                    Non ci sono dati da visualizzare
                </div>
            </div>
            )
        }
    }
}


